class CarImage {
  constructor(id, url) {
    this.id = id;
    this.url = url;
  }
}

export default CarImage;
